import { Box } from '@mui/material';
import { useEffect } from 'react';

export interface RenderIframeProps {
  name: string;
  onWindowMessageReceived: (event: MessageEvent) => void;
  urlIframe: string;
  height?: number | string;
  roundedCorners?: boolean;
  wrapperRef?: React.Ref<HTMLDivElement>;
}

const RenderIframe: React.FC<RenderIframeProps> = ({
  name,
  onWindowMessageReceived,
  urlIframe,
  height,
  roundedCorners = false,
  wrapperRef,
}: RenderIframeProps): JSX.Element => {
  useEffect(() => {
    window.addEventListener('message', onWindowMessageReceived, false);

    return () => {
      window.removeEventListener('message', onWindowMessageReceived, false);
    };

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Box px={3} ref={wrapperRef}>
      <iframe
        allow="autoplay; fullscreen; picture-in-picture"
        allowFullScreen
        src={urlIframe}
        style={{
          backgroundColor: 'white',
          border: 0,
          // inline iframes add a descender gap that overflows tight containers
          display: 'block',
          height: height ?? 'calc(100vh - 120px)',
          borderRadius: roundedCorners ? '8px' : '0px',
          marginTop: '4px',
        }}
        title={name}
        width="100%"
      />
    </Box>
  );
};

export default RenderIframe;
